import { useEffect } from "react";

export default function BrowserNotification() {
  useEffect(() => {
    if (!("Notification" in window)) {
    } else if (Notification.permission === "granted") {
    } else if (Notification.permission !== "denied") {
      Notification.requestPermission(function (permission) {
        if (permission === "granted") {
          console.info("Notificações liberadas");
        }
      });
    }
  }, []);

  return null;
}

export function spawnNotification(titile, body, icon, onClick) {
  if ("Notification" in window && Notification.permission === "granted") {
    var opcoes = {
      body: body,
      icon: icon,
    };
    var n = new Notification(titile, opcoes);
    n.onclick = onClick;
  }
}
